import styled from 'styled-components'

export const Restrict = styled.div`
	width: 100%;
	max-width: ${props => props.restrict === 'sml' ? "600px" : props.restrict === 'med' ? "900px" : props.restrict === 'lrg' ? "1360px" : "1600px"};
	margin: 0 auto;
`
